// extracted by mini-css-extract-plugin
module.exports = {"CopyButton_link":"CopyButton_CopyButton_link__2JK4_","CopyButton":"CopyButton_CopyButton__2bn8i","copy_col":"CopyButton_copy_col__3wVuB"};